import { BACKEND_URL } from "../../../../constants";

const URL = `${BACKEND_URL}/graphql`;

const QUERY = `
query (
  $drugNames: [String]!,
  $dFirst: Int!,
  $dInclude: Boolean!,
  $patientIsolateNamePairs: [PatientIsolateNamePairInput!]!,
  $iFirst: Int!,
  $iInclude: Boolean!
){
  viewer {
    luDrugs(drugNames: $drugNames, first: $dFirst) @include(if: $dInclude) {
      edges {
        node {
          drugName drugClass
        }
      }
    }
    isolates(patientIsolateNamePairs: $patientIsolateNamePairs, first: $iFirst) @include(if: $iInclude) {
      edges {
        node {
          patient {
            id
            ptAlias: pseudoName
          }
          isolateName
          suscResults {
            method
            drugName
            resultMatch
            result
            ic
            foldMatch
            fold
          }
        }
      }
    }
    lazy
  }
}`;


export default async function API({
  drugNames,
  patientIsolateNamePairs}) {

  drugNames = drugNames || [];
  patientIsolateNamePairs = patientIsolateNamePairs || [];

  const dFirst = drugNames.length;
  const dInclude = drugNames.length > 0;
  const iFirst = patientIsolateNamePairs.length;
  const iInclude = patientIsolateNamePairs.length > 0;


  const request = new Request(
    URL,
    {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        query: QUERY,
        variables: {
          drugNames: drugNames,
          patientIsolateNamePairs: patientIsolateNamePairs,
          dFirst: dFirst,
          dInclude: dInclude,
          iFirst: iFirst,
          iInclude: iInclude,
        }
      })
    });

  const resp = await fetch(request);
  const {data} =  await resp.json();

  return data;
}



// WEBPACK FOOTER //
// ./src/views/wizard/susc-results/hivdb/api.js